import React from "react";
import "./ExperiencePanel.css";
import P8Photo from "../assets/P8Photo.jpg"
import MobiPrintContPrintPhoto from "../assets/MobiPrintContPrintPhoto.jpg"
import HuskyRoboticsPhoto from "../assets/HuskyRoboticsPhoto.jpg"
import DronePhoto from "../assets/DronePhoto.jpg"

export const BoeingExperience = () => {
  return (
    <div className="photo-caption-container">
      <img
        src= {P8Photo}
        alt="Example"
        className="photo"
      />
      <div className="caption">
        <h3>Software Engineering Intern, The Boeing Company</h3>
        <p>validation and fixing of aircraft P-8 mission system software</p>
        <p>unit testing and build automation tooling</p>
      </div>
    </div>
  );
};

export const MakabilityLabExperience = () => {
  return (
    <div className="photo-caption-container">
      <img
        src= {MobiPrintContPrintPhoto}
        alt="Example"
        className="photo"
      />
      <div className="caption">
        <h3>Lab Assistant, University of Washington Makeability Lab</h3>
        <p>creating continuos printing platofrm from existing mobile 3D printer called MobiPrint</p>
        <p>integrate computer vision software to perform pose estimation on surroundings and state estimation</p>
        <p>worked on other prototype research software such as AR CAD app for smartphones</p>
      </div>
    </div>
  );
};

export const HuskyRoboticsExperience = () => {
  return (
    <div className="photo-caption-container">
      <img
        src= {HuskyRoboticsPhoto}
        alt="Example"
        className="photo"
      />
      <div className="caption">
        <h3>Software Engineer, Husky Robotics</h3>
        <p>maintain robot simulator ensuring robot kinematics, data and tools reflected the real world robot</p>
        <p>created software interfacing with different subsystems such as GPS, motor control boards and limit switches</p>
      </div>
    </div>
  );
};

export const DIYDroneExperience = () => {
  return (
    <div className="photo-caption-container">
      <img
        src= {DronePhoto}
        alt="Example"
        className="photo"
      />
      <div className="caption">
        <h3>DIYDrone</h3>
        <p>created drone C++ firmware to control motors, wirelessly communicate over radio modules and read IMU data</p>
        <p>designed and created power distribution board to interface with LiPo batteries using parts such as buck converters, fuses and resistors</p>
        <p>created and 3D printed drone frame designs using Onshape CAD software, CURA slicer and Ender 3 3D printer</p>
      </div>
    </div>
  );
};